import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getPrograms = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-programs/programs/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramById = ({ programId, version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-programs/programs/${programId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const retrieveProgramBySlug = ({ version = 'v1', slug, params }) =>
  client
    .request({
      url: `${version}/cp-programs/programs/slug/${slug}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramSlotPageBySlug = ({
  params = {},
  version = 'v1',
  programSlotSlug,
} = {}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/program-group-type/slug/${programSlotSlug}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateProgram = ({ version = 'v1', programUuid, payload }) =>
  client
    .request({
      url: `${version}/cp-programs/programs/${programUuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFavorites = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-programs/favorite/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createFavorite = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/cp-programs/favorite/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteFavorite = ({ version = 'v1', favoriteId }) =>
  client
    .request({
      url: `${version}/cp-programs/favorite/${favoriteId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFavoriteStudentPrograms = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-programs/favorite/student-programs/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramGroups = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-programs/program-groups/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramGroupPageBySlug = ({
  version = 'v1',
  params,
  programGroupSlug,
}) =>
  client
    .request({
      url: `${version}/cp-programs/program-groups/slug/${programGroupSlug}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProgramGroupTypes = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/program-group-type/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createProgramGroupType = ({ version = 'v1', payload }) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/program-group-type/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateProgramGroupType = ({
  version = 'v1',
  programGroupTypeId,
  payload,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/program-group-type/${programGroupTypeId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteProgramGroupType = ({
  version = 'v1',
  programGroupTypeId,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/program-group-type/${programGroupTypeId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getDistrictSettingsForStudent = ({ version = 'v1' }) =>
  client
    .request({
      url: `${version}/cp-programs/district-setting/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const fetchGradPlanRequirements = ({ version = 'v1', gradPlanUUID }) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/requirements-paths/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const fetchGradPlanAlternatesSettings = ({
  version = 'v1',
  gradPlanUUID,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/settings-alternates/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateGradPlanAlternatesSettings = ({
  version = 'v1',
  gradPlanUUID,
  payload,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/settings-alternates/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const fetchRequirementFulfillmentRules = ({
  version = 'v1',
  gradPlanUUID,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/requirement-fulfillment-rules/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateRequirementFulfillmentRules = ({
  version = 'v1',
  gradPlanUUID,
  payload,
}) =>
  client
    .request({
      url: `${version}/cp-graduation-plans/${gradPlanUUID}/requirement-fulfillment-rules/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
